import React from 'react';
import { v4 as uuid } from 'uuid';
import { PropertyType } from '../../../common';
import styles from './RowProvider.module.scss';
import { Link } from 'react-router-dom';
import { playersListMap } from './PlayerList.const';
import { find } from 'lodash';

export const getRows = (players: PropertyType[], columns: string[]): PropertyType[] => {
	const getActiveCells = (p: PropertyType): PropertyType[] => {
		const rows: PropertyType[] = [];
		columns.forEach((column) => {
			const field = find(playersListMap, ['label', column])?.key;
			const cellsMap = {
				player_id: <span key={uuid()}>{p.player_id}</span>,
				external_player_id: <span key={uuid()}>{p.external_player_id}</span>,
				vip_level_name: <span key={uuid()}>{p.vip_level_name}</span>,
				partner_skin: <span key={uuid()}>{p.partner_skin}</span>,
				user_name: (
					<span key={uuid()}>
						<Link
							to={`/players/player-list/${p.player_id}`}
							target='_blank'
							rel='noopener noreferrer'
							className={styles.Link}
						>
							{p.user_name || 'N/A'}
						</Link>
					</span>
				),
				email: <span key={uuid()}>{p.email}</span>,
				poker_user_name: (
					<span key={uuid()} className={styles.Link}>
						<Link
							to={`/players/player-list/${p.player_id}`}
							target='_blank'
							rel='noopener noreferrer'
							className={styles.Link}
						>
							{p.poker_user_name}
						</Link>
					</span>
				),
				first_name: <span key={uuid()}>{p.first_name}</span>,
				last_name: <span key={uuid()}>{p.last_name}</span>,
				country: <span key={uuid()}>{p.country}</span>,
				currency: <span key={uuid()}>{p.currency}</span>,
				first_activity: <span key={uuid()}>{p.first_activity}</span>,
				last_activity: <span key={uuid()}>{p.last_activity}</span>,
				last_known_ip: <span key={uuid()}>{p.last_known_ip}</span>,
				bet: (
					<span key={uuid()} className={styles.DataAmount}>
						{p.bet}
					</span>
				),
				win: (
					<span key={uuid()} className={styles.DataAmount}>
						{p.win}
					</span>
				),
				ggr: (
					<span key={uuid()} className={styles.DataAmount}>
						{p.ggr}
					</span>
				),
			};
			if (field) {
				rows.push((cellsMap as Record<string, JSX.Element>)[field]);
			}
		});
		return rows;
	};

	const data = players.map((s) => getActiveCells(s));
	return data;
};
